import axios from "axios";
import React, { createContext, useState } from "react";

export const WorkoutContext = createContext({});
const API_URL = process.env.REACT_APP_API_URL;

const WorkoutProvider = (props) => {
  const { children } = props;
  const [transactions, setTransactions] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [isLoadingWorkouts, setIsLoadingWorkouts] = useState(true);

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  // 記録を取得する処理
  const handleGetWorkouts = () => {
    setIsLoadingWorkouts(true);
    try {
      axios
        // .get(`${API_URL}/api/workouts/`)
        .get(`/api/workouts/`)
        .then((res) => {
          setTransactions(res.data);
        })
        .then((res) => {
          return sleep(1000).then(() => res);
        })
        .finally(() => {
          setIsLoadingWorkouts(false);
        });
    } catch (error) {
      console.error(error);
    }
  };

  // ワークアウトを保存する処理
  const handleSaveTransaction = (transaction) => {
    const data = {
      // user: 1, headerに含まれるTokenからDRFが自動で推論
      exercise: transaction.workout,
      category: transaction.category,
      date: transaction.date,
      memo: transaction.detail,
      sets: transaction.workoutSet,
    };
    axios
      .post(`${API_URL}/api/workouts/`, data) // headerには自動でTokenが入る
      .then((res) => {
        setTransactions([...transactions, res.data]);
      })
      .catch((error) => {
        console.error("error:", error);
        console.error("response:", error.response);
        console.error("data:", error.response?.data);
      });
  };

  const handleDeleteTransaction = (transactionIds) => {
    const idsToDelete = Array.isArray(transactionIds)
      ? transactionIds
      : [transactionIds];
    for (const id of idsToDelete) {
      axios.delete(`${API_URL}/api/workouts/${id}/`).then((res) => {
        setTransactions((prev) =>
          prev.filter((transaction) => transaction.id !== id),
        );
        // 以下3行でeditTask.idを初期化しないとcreateモードに入れない
        // if (editedTask.id === id) {
        // setEditedTask({ id: "", title: "" });
        // }
      });
    }
  };

  const handleUpdateTransaction = (editedTransaction, editedTransactionId) => {
    const data = {
      // user: 1, headerに含まれるTokenからDRFが自動で推論
      exercise: editedTransaction.workout,
      category: editedTransaction.category,
      date: editedTransaction.date,
      memo: editedTransaction.detail,
      sets: editedTransaction.workoutSet,
    };
    axios
      .put(`${API_URL}/api/workouts/${editedTransactionId}/`, data)
      .then((res) => {
        setTransactions(
          transactions.map((transaction) =>
            transaction.id === editedTransactionId ? res.data : transaction,
          ),
        );
      });
  };

  return (
    <WorkoutContext.Provider
      value={{
        transactions,
        setTransactions,
        isLoadingWorkouts,
        onGetWorkouts: handleGetWorkouts,
        onSaveTransaction: handleSaveTransaction,
        onDeleteTransaction: handleDeleteTransaction,
        onUpdateTransaction: handleUpdateTransaction,
        selectedTransaction,
        setSelectedTransaction,
      }}
    >
      {children}
    </WorkoutContext.Provider>
  );
};

export default WorkoutProvider;
